import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_picking_list_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_code: fromDatatype.VarcharDatatypeInterface;
    wms_layout_nodes_container_link_guid: fromDatatype.GuidDataFieldInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    qty_to_pick: fromDatatype.NumericDatatypeInterface;
    qty_picked: fromDatatype.NumericDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}


export class bl_wms_picking_list_line_RowClass
    implements bl_wms_picking_list_line_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
        fi_item_guid: fromDatatype.GuidDataFieldInterface;
        fi_item_code: fromDatatype.VarcharDatatypeInterface;
        inv_item_guid: fromDatatype.GuidDataFieldInterface;
        inv_item_code: fromDatatype.VarcharDatatypeInterface;
        wms_layout_nodes_container_link_guid: fromDatatype.GuidDataFieldInterface;
        scan_code: fromDatatype.VarcharDatatypeInterface;
        qty_to_pick: fromDatatype.NumericDatatypeInterface;
        qty_picked: fromDatatype.NumericDatatypeInterface;
        status: fromDatatype.StatusDataFieldInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
        gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}